"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const RightsholderMaintenanceContactEdit_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceContactTab/RightsholderMaintenanceContactEdit"));
const RightsholderMaintenanceContactView_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceContactTab/RightsholderMaintenanceContactView"));
const tabs_constants_1 = require("@Const/tabs-constants");
const contexts_1 = require("@App/contexts");
const RightsholderMaintenanceContactTab = () => {
    const [pending, setPending] = (0, react_1.useState)(false);
    const [isEditable, setEditable] = (0, react_1.useState)(false);
    const { popupStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const checkPending = () => {
        const memberSummary = rightsholderStore.memberSummary;
        if (memberSummary.pending) {
            popupStore.setTabsAlertData('Your updates have been saved and are pending validation.\n' +
                'Please check back in 24 hours to see changes reflected.', tabs_constants_1.MAINTENANCE_TABS.mailingAndContact.name, false, true);
            setPending(true);
        }
        else {
            popupStore.setTabsAlertData('', tabs_constants_1.MAINTENANCE_TABS.mailingAndContact.name, false, true);
            setPending(false);
        }
    };
    (0, react_1.useEffect)(checkPending, []);
    return isEditable ? (react_1.default.createElement(RightsholderMaintenanceContactEdit_1.default, { pending: pending, checkPending: checkPending, setEditable: setEditable })) : (react_1.default.createElement(RightsholderMaintenanceContactView_1.default, { pending: pending, setEditable: setEditable }));
};
exports.default = (0, mobx_react_1.observer)(RightsholderMaintenanceContactTab);
